export default "__VITE_ASSET__jHfYh7cA__"